 angular
 .module('vppApp')
 .service('UpdateAccountService', UpdateAccountService);
 UpdateAccountService.$inject = ['$http', '$rootScope'];
 function UpdateAccountService($http, $rootScope) {
	 var updateAccountService = {};
	 var _accountDetails = {};
	 var _securityDetails = {};
	 var _moduleDetails = {};

	 updateAccountService.setAccountDetails = function (accountDetails) {
		 _accountDetails = accountDetails;
	 };
	 updateAccountService.setSecurityDetails = function (securityDetails) {
		 _securityDetails = securityDetails;
	 };
	 updateAccountService.setModuleDetails = function (moduleDetails) {
		 _moduleDetails = moduleDetails;
	 };
	 updateAccountService.buildRegistrationObj = function (whichSite) {
		 // builds the Registration json Object for API
		 // console.log(_accountDetails);
		 //console.log(_securityDetails);
		 // console.log(_moduleDetails);
		 var _tempRegisterObj;
		 if (whichSite === 'emp') {
			 _tempRegisterObj = angular.merge({}, _accountDetails, _securityDetails);
			 _tempRegisterObj = angular.toJson(_tempRegisterObj);
			 return _tempRegisterObj;
		 } else {
			 _tempRegisterObj = angular.merge({}, _accountDetails, _securityDetails, _moduleDetails);
			 _tempRegisterObj = angular.toJson(_tempRegisterObj);
			 return _tempRegisterObj;
		 }
	 };
	 return updateAccountService;
 }